import React, { memo } from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import pageStyles from "./../../pages/pageStyles";

export interface SectionWrapperProps {
  title?: string;
  icon?: JSX.Element;
  children: JSX.Element | JSX.Element[];
  isChild?: boolean;
  isWhiteBG?: boolean;
}

const SectionWrapper = ({
  title,
  icon,
  children,
  isChild,
  isWhiteBG = false,
}: SectionWrapperProps) => {
  const classes = pageStyles();

  return (
    <Paper
      elevation={0}
      className={isChild ? classes.sectionWrapperChild : classes.sectionWrapper}
      style={{ background: isWhiteBG ? "#fff" : "" }}
    >
      <Grid
        item
        xs={12}
        className={
          isChild ? classes.sectionHeadingChild : classes.sectionHeading
        }
      >
        <Typography
          variant="h5"
          display="block"
          className={
            isChild
              ? classes.sectionHeadingTitleChild
              : classes.sectionHeadingTitle
          }
          sx={{ display: "flex", alignItems: "center" }}
        >
          {title}
          {icon}
        </Typography>
      </Grid>

      <Box className={classes.sectionContentWrapper}>
        <Grid container spacing={2}>
          <Grid item container>
            {children}
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};

export default memo(SectionWrapper);
